import {Injectable} from "@angular/core";
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from "@angular/router";
import {AuthenticationService} from "../service/authentication.service";
// import {AuthenticationService} from "../service/authentication.service";


@Injectable()
export class AuthenticationGuard implements CanActivate {
    constructor(
        // private router: Router,
        private as: AuthenticationService,
        private router: Router
    ) {
    }

    // @ts-ignore
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.as.isConnected()) {
            return true
        } else {
            this.router.navigateByUrl('/auth/login');
        }
        return false
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/authentication/guard/authentication.guard.ts